<template>
  <el-dialog :visible.sync="open" title="Link event">
    <el-form label-width="140px" @keyup.enter.native="update">
      <el-form-item label="Event">
        <el-select v-model="event" placeholder="Select" filterable="filterable">
          <el-option v-for="event in events" :key="event.id" :label="event.alias" :value="event.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form><span class="dialog-footer" slot="footer">
      <el-button @click="close">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="update">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['badge', 'open'],
  data () {
    return {
      lang: 'fr',
      event: null,
      eventSelected: null
    }
  },
  computed: {
    ...mapGetters('events', {
      events: 'events'
    })
  },
  watch: {
    event () {
      this.events.forEach((evt) => {
        if (this.event === evt.id) {
          this.eventSelected = evt
        }
      })
    }
  },
  methods: {
    ...mapActions('badges', ['linkEvent']),

    close () {
      this.$emit('close')
    },
    update () {
      this.linkEvent({ badge: this.badge, event: this.eventSelected, sitekey: this.$route.params.site })
        .then(() => {
          this.$notify({title: 'Success', message: this.$root.$t('notifications.badge.edited')})
          this.$emit('close')
        }).catch(() => {
          this.$notify.error({title: 'Error', message: this.$root.$t('notifications.unknown')})
          this.$emit('close')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/badges/LinkEvent.vue